import * as React from 'react';
import Text from 'antd/lib/typography/Text';
import { antGrey } from '../styles/globalStyles';
import { selectCurrentSubscriptionStatus } from '../../selectors/selectors';
import { useSelector } from 'react-redux';
import Link from 'antd/lib/typography/Link';
import { displaySubscriptionStatus } from '../../helpers/displayHelpers';

export const RestrictedStepBanner: React.FC = () => {
    const currentSubscriptionStatus = useSelector(selectCurrentSubscriptionStatus);

    return (
        <div
            style={{
                backgroundColor: antGrey.grey3,
                padding: '24px 36px',
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <Text style={{ fontWeight: 600, color: antGrey.grey8 }}>
                This step is not available on the {displaySubscriptionStatus(currentSubscriptionStatus, true)} plan.{' '}
                <Text
                    style={{
                        color: antGrey.grey7,
                        fontWeight: 400,
                    }}
                >
                    <Link href={`#hs-chat-open`}>Get in touch</Link> to upgrade your organization’s plan.
                </Text>
            </Text>
        </div>
    );
};
